import { LOCALES } from '@marketplace/i18n';

export const registrationFormI18n = {
  [LOCALES.ENG]: {
    registrationContactInformation_email: 'E-mail address',
    registrationContactInformation_firstName: 'First name',
    registrationContactInformation_lastName: 'Last name',
    registrationContactInformation_phone: 'Mobile Phone',
    registrationPassword_password: 'Password',
    registrationPassword_confirmPassword: 'Confirm password',
    registrationLocation_companyName: 'Company Name',
    registrationLocation_address: 'Address',
    registrationLocation_country: 'Country',
    registrationLocation_state: 'State / Province',
    registrationLocation_city: 'City',
    registrationLocation_postalCode: 'Postal Code',
    registrationLocation_term1: 'Please download and read the {terms} and our {code}',
    registrationLocation_term2: 'Terms of Service',
    registrationLocation_term3: 'Code of Developer Best Practices',
    registrationLocation_agree:
      'I have read and accept the Terms of Service and will comply with the Code Developer Best Practices.',
    registrationLocation_agreeV2:
      'I have read and accepted the Terms of Service and will comply with the Code Developer Best Practices.',
    registrationFormFeature_success: 'Success',
    registrationFormHeader: 'Create your account',
    registrationFormDataCollection1:
    'This website collects personal information including the items below. If you want to find out more about the personal information we collect and use, you can view our {privacy_policy}',
    registrationFormDataCollection2: 'Privacy Policy',
    registrationFormGWHUserMessage:
    "As a Greenway employee or contractor, please log in using your workforce credentials. If your credentials don't enable access to the Developer Platform, please make a service request to be added to the appropriate group.",
    registrationMobilePlaceholder: 'Input {field}',
    emailExistsInBothGISAndDPDatabaseMessage:'Error creating this user account. Ensure no account exists with this email address. ',
    emailExistsInGISDatabaseNotInDPMessage:'There is an error creating this user account. For assistance, ',
    registrationFormGWHUserAllowedMessage:'Only Greenway domain emails are allowed'
  },
};
